import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { blockElm: String, format: String }

  connect() {
    // console.log("Hello, ClipboardController!", this.element);
  }

  copy() {
    const target_block_elm = document.querySelector(this.blockElmValue);
    const target_block_type= this.formatValue;

    if (typeof navigator.clipboard.write === "function") {
      // safe to use the function
      __copyToClipboard(target_block_elm.innerHTML, target_block_type)
      // alert('Inhoud gekopieerd naar clipboard');
    } else {
      // IE? Works only with text (not HTML)
      target_block_elm.select();
      document.execCommand("copy");
    }

    event.stopPropagation();
  }  
}


/* 
  content: text or HTML 
  format: text, html, image
*/
async function __copyToClipboard(content, format) {

  if (format=='text') {
    navigator.clipboard.writeText(content).then(
    () => {
      /* clipboard successfully set */
      console.log('Content copied to clipboard');
    },
    () => {
      /* clipboard write failed */
      console.log('Failed to copy content to clipboard');
    })
  } else {
    let type = `text/${format}`;
    const blob = new Blob([content], { type });
    const data = [new ClipboardItem({ [type]: blob })];
    await navigator.clipboard.write(data).then(
    () => {
      /* clipboard successfully set */
      console.log('Content copied to clipboard');
    },
    () => {
      /* clipboard write failed */
      console.log('Failed to copy content to clipboard');
    })
  }

}